module.exports = __webpack_public_path__ + "img/38.f76b1697.png";